import {Colors, FlexBox, MagicBox} from "@brg/ui";
import { LayoutConst } from "core";
import styled, { css } from "styled-components";
import Chevron from "../assets/Chevron.svg"
import Question from "../assets/Question.svg"
import QuestionDark from "../assets/QuestionDark.svg"
import StarIcon from "../assets/Star.svg"
import { QueueMode } from "./QueueNew";

export const QueueWrapper = styled.div<{
    isBlue?: boolean
    isBook?: boolean
    hidden?: boolean
    mode?: QueueMode
}>` 
    width: 100%;
    position: relative;
    padding: 24px;
    background-color: ${p => p?.isBook ? Colors.galBlack5 : p.isBlue ? Colors.generalDenimBlue : Colors.gal};
    // border-radius: 8px;
    display: ${p => p.hidden ? "none" : "flex"};
    align-items: center;
    flex-direction: column;
    // gap: 60px;
    gap: ${({ mode }) => mode === QueueMode.view ? '0' : '38px' };
    flex-shrink: 0;
    overflow-x: hidden;
    margin-bottom: ${({ isBook }) => isBook ? '0' : '24px' };
    z-index: 2;
    box-shadow: 0px 4px 4px 0px #0000001F;

    ${({ mode }) => mode === QueueMode.view && css`
        padding: 24px 48px;
    `};

    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px){
        width: 888px;
        padding: ${({ mode }) => mode === QueueMode.view ? '24px 36px' : '24px' };
    }
  
  
    @media (max-width: ${LayoutConst.screen.l}px){
        width: calc(100% - 32px);
        gap: 32px;
        padding: ${({ mode }) => mode === QueueMode.view ? '16px 24px' : '24px' };
    }

  @media screen and (max-width: ${LayoutConst.screen.s-1}px) {
    width: 100%;
    border-radius: 0;
    padding: ${({ mode }) => mode === QueueMode.view ? '16px 10px' : '24px 10px' };
  }
`

export const QueueTopWrapper = styled.div<{ mode: QueueMode}>`
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 100%;

    ${({ mode }) => mode === QueueMode.create && css`
        position: absolute;
        gap: 16px;
        left: 24px;
        width: calc(100% - 48px);
    `};
    @media screen and (max-width: ${LayoutConst.screen.s-1}px) {
        position: initial;
        justify-content: flex-start;
        width: 100%;
    }
`

export const QueueTitle = styled(MagicBox)`
    font-family: Inter;
    font-size: 30px;
    font-weight: 500;
    line-height: 40px;
    letter-spacing: -0.02em;
    text-align: left;
    color: ${Colors.galBlack100};

    @media screen and (max-width: ${LayoutConst.screen.s-1}px) {
        font-size: 22px;
        font-weight: 600;
        line-height: 28px;
    }
`

export const QueueTariff = styled(FlexBox)`
height: 30px;
justify-content: center;
align-items: center;
background-color:#7CB1FF;
border-radius: 5px;
padding: 5px 16px;
color: ${Colors.galBlack100};
font-family: Inter;
font-size: 15px;
font-style: normal;
font-weight: 400;
line-height: 20px;

`

export const QueueNumberInfoWrapper = styled.div`
    display: flex;
    gap: 48px;
    align-items: center;

    @media (max-width: ${LayoutConst.screen.m}px) {
        display: grid;
        grid-template-columns: 1fr 1fr;
        row-gap: 16px;
        column-gap: 32px;
        width: fit-content;
        align-items: flex-start;
    }
`

export const QueueNumberInfoBlock = styled.div`
    cursor: pointer;
    display: flex;
    flex-direction: column;
    gap: 2px;

    @media screen and (max-width: ${LayoutConst.screen.m}px) {
        width: fit-content;
    }
`

export const QueueBottomWrapper = styled.div`
    position: relative;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;

    @media screen and (max-width: ${LayoutConst.screen.sm}px) {
        flex-direction: column;
    }
`

export const QueueBottomDescriptionWrapper = styled.div`
  margin-top: 4px;
  color: ${Colors.galBlack47};
  font-family: Inter;
  font-size: 13px;
  font-weight: 400;
  line-height: 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  @media screen and (max-width: ${LayoutConst.screen.m}px) {
    // flex-direction: row;
    width: 100%;
    margin-top: 12px;
    justify-content: space-between;
  }

    @media screen and (max-width: ${LayoutConst.screen.s-1}px) {
    justify-content: space-between;
    margin-top: 16px;
  }

    @media screen and (max-width: ${LayoutConst.screen.sm}px) {
    flex-direction: column;
    width: 100%;
    margin-top: 12px;

    div {
        width: 100%;
    }
  }
  

`


export const QueueNumberInfoTitle = styled.div<{
    isBlue?: boolean
}>`
    font-family: Inter;
    font-size: 13px;
    font-weight: 400;
    line-height: 18px;
    letter-spacing: -0.02em;
    color: ${p => p.isBlue ? Colors.gal : Colors.galBlack47};

    @media screen and (max-width: ${LayoutConst.screen.m}px) {
        max-width: 105px;
    }
`

export const QueueInfoNumber = styled.div<{
    isBlue?: boolean
}>`
    font-family: Inter;
    font-size: 23px;
    font-weight: 500;
    line-height: 29px;
    letter-spacing: -0.02em;
    color: ${p => p.isBlue ? Colors.gal : Colors.galBlack100};
    display: flex;
    align-items: center;

    @media (max-width: ${LayoutConst.screen.m}px) {
        font-weight: 500;
        font-size: 20px;
        line-height: 25px;
    }
`


export const QueueBottomRight = styled.div`
    display: flex;
    gap: 48px;
    align-items: center;

    @media screen and (max-width: ${LayoutConst.screen.sm}px) {
        margin-top: 16px;
        flex-direction: column;
        align-items: flex-start;
        width: 100%;
        gap: 8px;
    }
`

export const ChevronDown = styled.div<{
    expanded?: boolean
}>`
    width: 12px;
    height: 12px;
    background-image: url(${Chevron});
    transform: rotateZ(${p => p.expanded ? "180" : "0"}deg);
`

const CopyButton = styled.button`
    cursor: pointer;
    user-select: none;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 12px 48px;

    border-radius: 3px;
    border: none;

    font-family: Inter;
    font-size: 17px;
    line-height: 22px;
    letter-spacing: -0.02em;

    @media screen and (max-width: ${LayoutConst.screen.sm}px) {
        width: 100%;
    }
`

export const BuyQueueButton = styled(CopyButton)`
    background-color: ${Colors.geo};
    font-weight: 600;
    color: ${Colors.gal};

    :disabled {
        cursor: default;
        opacity: 0.3;
    }


`

export const GoToCopyButton = styled(CopyButton)`
    border: 1px solid ${Colors.galBlack31};
    font-weight: 600;
`

export const HoverHint = styled.div<{
    direction: "right" | "top"
    isBelowCurrent?: boolean
    offsetX?: number
    offsetY?: number
}>`
    position: absolute;
    z-index: 50;
    background-color: ${Colors.galBlack100};
    max-width: min(50vw, 500px);
    border-radius: 6px;
    padding: 12px 16px;
    transition: 0.2s;
    transform-origin: ${p => p.direction === "right" ? "left top" :
                                p.direction === "top" ? 
                                p.isBelowCurrent ? "left bottom" : "right bottom" : 
                                "auto"
                        };
    transform: scale(0);
    box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.12);

    ${p => p.direction === "right" && css`
        left: ${(p.offsetX ?? 0) + 13}px;
        top: ${(p.offsetY ?? 0) - 9}px;
    `}

    ${p => p.direction === "top" && css`
        left: ${p.isBelowCurrent ? `${(p.offsetX ?? 0)}px` : "auto"};
        right: ${!p.isBelowCurrent ? `${(p.offsetX ?? 0)}px` : "auto"};
        bottom: ${(p.offsetY ?? 0) + 13}px;
    `}

    font-family: Inter;
    font-size: 13px;
    font-weight: 400;
    line-height: 16px;
    white-space: nowrap;
    color: ${Colors.gal};

    &::before {
        content: "";
        position: absolute;

        ${p => p.direction === "right" && css`
            top: 16px;
            left: -4px;
        `}

        ${p => p.direction === "top" && css`
            left: ${p.isBelowCurrent ? "16px" : "auto"};
            right: ${!p.isBelowCurrent ? "16px" : "auto"};
            bottom: -4px;
        `}
        
        width: 8px;
        height: 8px;
        transform: rotateZ(45deg);
        background-color: ${Colors.galBlack100};

    }

`

export const HoverHintMobile = styled.div<{
    direction: "top" | "bottom"
    wrap?: boolean
    circleOffset: number
    circleSize: number
}>`
    position: absolute;
    z-index: 50;
    background-color: ${Colors.galBlack100};
    border-radius: 6px;
    padding: 12px 16px;
    transition: 0.2s;
    max-width: calc(90vw - 24px);
    width: calc(90vw - 24px);
    box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.12);
    left: ${p => -p.circleOffset-33}px;

    transform-origin: center;
    transform: scale(0);

    ${p => p.direction === "top" && css`
            bottom: ${p.circleSize + 10}px;
    `}

    ${p => p.direction === "bottom" && css`
            top: 40px;
    `}

    font-family: Inter;
    font-size: 13px;
    font-weight: 400;
    line-height: 16px;
    white-space: ${p => p.wrap ? "normal" : "nowrap"};
    color: ${Colors.gal};

    &::before {
        content: "";
        position: absolute;
        left: ${p => p.circleOffset + p.circleSize/2 + 30}px;

        ${p => p.direction === "top" && css`
            top: 52px;
        `}

        ${p => p.direction === "bottom" && css`
            bottom: 68px;
        `}

        width: 8px;
        height: 8px;
        transform: rotateZ(45deg);
        background-color: ${Colors.galBlack100};
    }

`

export const QuestionButton = styled.div<{
    dark?: boolean
}>`
    cursor: pointer;
    position: absolute;
    top: 24px;
    right: 24px;
    width: 32px;
    height: 32px;
    background-image: ${p => p.dark ? `url(${QuestionDark})` : `url(${Question})`};

    background-size: cover;

    &:hover {
        filter: brightness(${p => p.dark ? 1.1 : 1.1});
        z-index: 10000;
    }
    
    &:hover ${HoverHint} {
        transform: scale(1);
    }

    &:hover ${HoverHintMobile} {
        transform: scale(1);
    }
    
    @media screen and (max-width: ${LayoutConst.screen.s-1}px) {
        top: 16px;
        right: 16px;
        width: 24px;
        height: 24px;
    }
`

export const Star = styled.div`
    width: 16px;
    height: 16px;
    margin-right: 4px;
    background-image: url(${StarIcon});
    background-repeat: no-repeat;
`

export const QueueTopHint = styled.div<{
    isPrint?: boolean
    queueSize?: number
}>`
    position: absolute;
    top: 67px;
    left: 0;
    right: 0;
    margin: auto;
    margin-left: 24px;
    margin-right: 24px;
    text-align: ${p => p.queueSize === 1 ? "left" : "center"};

    font-family: Inter;
    font-size: 13px;
    font-weight: 700;
    line-height: 16px;
    color: ${p => p.isPrint ? Colors.gal : Colors.generalPeaGreen}
`

export const QueueViewLineContainer = styled(MagicBox)`
    // min-height: 149px;
    min-height: 75px;

    @media screen and (max-width: ${LayoutConst.screen.md}px) {
        min-height: 60px;
    }

    @media screen and (max-width: ${LayoutConst.screen.s - 1}px) {
        min-height: 50px;
    }
`

export const QueueCardContainer = styled.div`
// height: 118px;
width: 100%;
margin-top:18px!important;


    @media screen and (max-width: ${LayoutConst.screen.mac13}px) {
        margin-top: 16px!important;
    }

        @media screen and (max-width: ${LayoutConst.screen.l}px) {
        margin-top: 12px!important;
    }

    @media screen and (max-width: ${LayoutConst.screen.s-1}px) {
        margin-top: 24px!important;
    }
`;

export const QueueSubtitle = styled.div`
color:${Colors.galBlack73};
font-family: Inter;
font-size: 17px;
font-weight: 600;
line-height: 22px; 
letter-spacing: -0.02em;

@media screen and (max-width: ${LayoutConst.screen.s-1}px) {
    font-size: 15px;
    line-height: 20px; 
}
`;

export const SerialСardsContainer = styled.div`
display: flex;
flex-direction: row;
width: 100%;
max-height: 80px;
align-items: flex-start;
flex-wrap: wrap;
overflow-y: scroll;
margin-top: 16px;
gap:16px 24px;
padding-right:10px;

::-webkit-scrollbar {
    width: 2px;
    height: 48px;
}

::-webkit-scrollbar-track {
    background-color:${Colors.galBlack5};
}

::-webkit-scrollbar-thumb {
    background-color:${Colors.galBlack47};
}

  @media screen and (max-width: ${LayoutConst.screen.mac13}px) {
    gap:8px 16px;
  }

  @media screen and (max-width: ${LayoutConst.screen.s-1}px) {
    gap:8px 12px;
  }
`

export const SerialСard = styled.a`
color: ${Colors.galBlack100};
padding: 5px 16px;
border: 1px solid ${Colors.galBlack61};
border-radius: 5px;
cursor:pointer;
font-family: Inter;
font-size: 17px;
font-weight: 400;
line-height: 22px; 
letter-spacing: -0.02em;
max-width: 71px;
max-height: 32px;
box-sizing: border-box;

:hover{
    color:${Colors.galBlack100};
}

@media screen and (max-width: ${LayoutConst.screen.mac13}px) {
    font-size: 13px;
    line-height: 16px; 
    max-width: 62px;
    max-height: 26px;
}
`
import {Colors, FlexBox, MagicBox} from "@brg/ui";
import { LayoutConst } from "core";
import styled, { css } from "styled-components";
import Chevron from "../assets/Chevron.svg"
import Question from "../assets/Question.svg"
import QuestionDark from "../assets/QuestionDark.svg"
import StarIcon from "../assets/Star.svg"
import { QueueMode } from "./QueueNew";

export const QueueWrapper = styled.div<{
    isBlue?: boolean
    isBook?: boolean
    hidden?: boolean
    mode?: QueueMode
}>` 
    width: 100%;
    position: relative;
    padding: 24px;
    background-color: ${p => p?.isBook ? Colors.galBlack5 : p.isBlue ? Colors.generalDenimBlue : Colors.gal};
    // border-radius: 8px;
    display: ${p => p.hidden ? "none" : "flex"};
    align-items: center;
    flex-direction: column;
    // gap: 60px;
    gap: ${({ mode }) => mode === QueueMode.view ? '0' : '38px' };
    flex-shrink: 0;
    overflow-x: hidden;
    margin-bottom: ${({ isBook }) => isBook ? '0' : '24px' };
    z-index: 2;
    box-shadow: 0px 4px 4px 0px #0000001F;

    ${({ mode }) => mode === QueueMode.view && css`
        padding: 24px 48px;
    `};

    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px){
        width: 888px;
        padding: ${({ mode }) => mode === QueueMode.view ? '24px 36px' : '24px' };
    }
  
  
    @media (max-width: ${LayoutConst.screen.l}px){
        width: calc(100% - 32px);
        gap: 32px;
        padding: ${({ mode }) => mode === QueueMode.view ? '16px 24px' : '24px' };
    }

  @media screen and (max-width: ${LayoutConst.screen.s-1}px) {
    width: 100%;
    border-radius: 0;
    padding: ${({ mode }) => mode === QueueMode.view ? '16px 10px' : '24px 10px' };
  }
`

export const QueueTopWrapper = styled.div<{ mode: QueueMode}>`
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 100%;

    ${({ mode }) => mode === QueueMode.create && css`
        position: absolute;
        gap: 16px;
        left: 24px;
        width: calc(100% - 48px);
    `};
    @media screen and (max-width: ${LayoutConst.screen.s-1}px) {
        position: initial;
        justify-content: flex-start;
        width: 100%;
    }
`

export const QueueTitle = styled(MagicBox)`
    font-family: Inter;
    font-size: 30px;
    font-weight: 500;
    line-height: 40px;
    letter-spacing: -0.02em;
    text-align: left;
    color: ${Colors.galBlack100};

    @media screen and (max-width: ${LayoutConst.screen.s-1}px) {
        font-size: 22px;
        font-weight: 600;
        line-height: 28px;
    }
`

export const QueueTariff = styled(FlexBox)`
height: 30px;
justify-content: center;
align-items: center;
background-color:#7CB1FF;
border-radius: 5px;
padding: 5px 16px;
color: ${Colors.galBlack100};
font-family: Inter;
font-size: 15px;
font-style: normal;
font-weight: 400;
line-height: 20px;

`

export const QueueNumberInfoWrapper = styled.div`
    display: flex;
    gap: 48px;
    align-items: center;

    @media (max-width: ${LayoutConst.screen.m}px) {
        display: grid;
        grid-template-columns: 1fr 1fr;
        row-gap: 16px;
        column-gap: 32px;
        width: fit-content;
        align-items: flex-start;
    }
`

export const QueueNumberInfoBlock = styled.div`
    cursor: pointer;
    display: flex;
    flex-direction: column;
    gap: 2px;

    @media screen and (max-width: ${LayoutConst.screen.m}px) {
        width: fit-content;
    }
`

export const QueueBottomWrapper = styled.div`
    position: relative;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;

    @media screen and (max-width: ${LayoutConst.screen.sm}px) {
        flex-direction: column;
    }
`

export const QueueBottomDescriptionWrapper = styled.div`
  margin-top: 4px;
  color: ${Colors.galBlack47};
  font-family: Inter;
  font-size: 13px;
  font-weight: 400;
  line-height: 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  @media screen and (max-width: ${LayoutConst.screen.m}px) {
    // flex-direction: row;
    width: 100%;
    margin-top: 12px;
    justify-content: space-between;
  }

    @media screen and (max-width: ${LayoutConst.screen.s-1}px) {
    justify-content: space-between;
    margin-top: 16px;
  }

    @media screen and (max-width: ${LayoutConst.screen.sm}px) {
    flex-direction: column;
    width: 100%;
    margin-top: 12px;

    div {
        width: 100%;
    }
  }
  

`


export const QueueNumberInfoTitle = styled.div<{
    isBlue?: boolean
}>`
    font-family: Inter;
    font-size: 13px;
    font-weight: 400;
    line-height: 18px;
    letter-spacing: -0.02em;
    color: ${p => p.isBlue ? Colors.gal : Colors.galBlack47};

    @media screen and (max-width: ${LayoutConst.screen.m}px) {
        max-width: 105px;
    }
`

export const QueueInfoNumber = styled.div<{
    isBlue?: boolean
}>`
    font-family: Inter;
    font-size: 23px;
    font-weight: 500;
    line-height: 29px;
    letter-spacing: -0.02em;
    color: ${p => p.isBlue ? Colors.gal : Colors.galBlack100};
    display: flex;
    align-items: center;

    @media (max-width: ${LayoutConst.screen.m}px) {
        font-weight: 500;
        font-size: 20px;
        line-height: 25px;
    }
`


export const QueueBottomRight = styled.div`
    display: flex;
    gap: 48px;
    align-items: center;

    @media screen and (max-width: ${LayoutConst.screen.sm}px) {
        margin-top: 16px;
        flex-direction: column;
        align-items: flex-start;
        width: 100%;
        gap: 8px;
    }
`

export const ChevronDown = styled.div<{
    expanded?: boolean
}>`
    width: 12px;
    height: 12px;
    background-image: url(${Chevron});
    transform: rotateZ(${p => p.expanded ? "180" : "0"}deg);
`

const CopyButton = styled.button`
    cursor: pointer;
    user-select: none;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 12px 48px;

    border-radius: 3px;
    border: none;

    font-family: Inter;
    font-size: 17px;
    line-height: 22px;
    letter-spacing: -0.02em;

    @media screen and (max-width: ${LayoutConst.screen.sm}px) {
        width: 100%;
    }
`

export const BuyQueueButton = styled(CopyButton)`
    background-color: ${Colors.geo};
    font-weight: 600;
    color: ${Colors.gal};

    :disabled {
        cursor: default;
        opacity: 0.3;
    }


`

export const GoToCopyButton = styled(CopyButton)`
    border: 1px solid ${Colors.galBlack31};
    font-weight: 600;
`

export const HoverHint = styled.div<{
    direction: "right" | "top"
    isBelowCurrent?: boolean
    offsetX?: number
    offsetY?: number
}>`
    position: absolute;
    z-index: 50;
    background-color: ${Colors.galBlack100};
    max-width: min(50vw, 500px);
    border-radius: 6px;
    padding: 12px 16px;
    transition: 0.2s;
    transform-origin: ${p => p.direction === "right" ? "left top" :
                                p.direction === "top" ? 
                                p.isBelowCurrent ? "left bottom" : "right bottom" : 
                                "auto"
                        };
    transform: scale(0);
    box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.12);

    ${p => p.direction === "right" && css`
        left: ${(p.offsetX ?? 0) + 13}px;
        top: ${(p.offsetY ?? 0) - 9}px;
    `}

    ${p => p.direction === "top" && css`
        left: ${p.isBelowCurrent ? `${(p.offsetX ?? 0)}px` : "auto"};
        right: ${!p.isBelowCurrent ? `${(p.offsetX ?? 0)}px` : "auto"};
        bottom: ${(p.offsetY ?? 0) + 13}px;
    `}

    font-family: Inter;
    font-size: 13px;
    font-weight: 400;
    line-height: 16px;
    white-space: nowrap;
    color: ${Colors.gal};

    &::before {
        content: "";
        position: absolute;

        ${p => p.direction === "right" && css`
            top: 16px;
            left: -4px;
        `}

        ${p => p.direction === "top" && css`
            left: ${p.isBelowCurrent ? "16px" : "auto"};
            right: ${!p.isBelowCurrent ? "16px" : "auto"};
            bottom: -4px;
        `}
        
        width: 8px;
        height: 8px;
        transform: rotateZ(45deg);
        background-color: ${Colors.galBlack100};

    }

`

export const HoverHintMobile = styled.div<{
    direction: "top" | "bottom"
    wrap?: boolean
    circleOffset: number
    circleSize: number
}>`
    position: absolute;
    z-index: 50;
    background-color: ${Colors.galBlack100};
    border-radius: 6px;
    padding: 12px 16px;
    transition: 0.2s;
    max-width: calc(90vw - 24px);
    width: calc(90vw - 24px);
    box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.12);
    left: ${p => -p.circleOffset-33}px;

    transform-origin: center;
    transform: scale(0);

    ${p => p.direction === "top" && css`
            bottom: ${p.circleSize + 10}px;
    `}

    ${p => p.direction === "bottom" && css`
            top: 40px;
    `}

    font-family: Inter;
    font-size: 13px;
    font-weight: 400;
    line-height: 16px;
    white-space: ${p => p.wrap ? "normal" : "nowrap"};
    color: ${Colors.gal};

    &::before {
        content: "";
        position: absolute;
        left: ${p => p.circleOffset + p.circleSize/2 + 30}px;

        ${p => p.direction === "top" && css`
            top: 52px;
        `}

        ${p => p.direction === "bottom" && css`
            bottom: 68px;
        `}

        width: 8px;
        height: 8px;
        transform: rotateZ(45deg);
        background-color: ${Colors.galBlack100};
    }

`

export const QuestionButton = styled.div<{
    dark?: boolean
}>`
    cursor: pointer;
    position: absolute;
    top: 24px;
    right: 24px;
    width: 32px;
    height: 32px;
    background-image: ${p => p.dark ? `url(${QuestionDark})` : `url(${Question})`};

    background-size: cover;

    &:hover {
        filter: brightness(${p => p.dark ? 1.1 : 1.1});
        z-index: 10000;
    }
    
    &:hover ${HoverHint} {
        transform: scale(1);
    }

    &:hover ${HoverHintMobile} {
        transform: scale(1);
    }
    
    @media screen and (max-width: ${LayoutConst.screen.s-1}px) {
        top: 16px;
        right: 16px;
        width: 24px;
        height: 24px;
    }
`

export const Star = styled.div`
    width: 16px;
    height: 16px;
    margin-right: 4px;
    background-image: url(${StarIcon});
    background-repeat: no-repeat;
`

export const QueueTopHint = styled.div<{
    isPrint?: boolean
    queueSize?: number
}>`
    position: absolute;
    top: 67px;
    left: 0;
    right: 0;
    margin: auto;
    margin-left: 24px;
    margin-right: 24px;
    text-align: ${p => p.queueSize === 1 ? "left" : "center"};

    font-family: Inter;
    font-size: 13px;
    font-weight: 700;
    line-height: 16px;
    color: ${p => p.isPrint ? Colors.gal : Colors.generalPeaGreen}
`

export const QueueViewLineContainer = styled(MagicBox)`
    // min-height: 149px;
    min-height: 75px;

    @media screen and (max-width: ${LayoutConst.screen.md}px) {
        min-height: 60px;
    }

    @media screen and (max-width: ${LayoutConst.screen.s - 1}px) {
        min-height: 50px;
    }
`

export const QueueCardContainer = styled.div`
// height: 118px;
width: 100%;
margin-top:18px!important;


    @media screen and (max-width: ${LayoutConst.screen.mac13}px) {
        margin-top: 16px!important;
    }

        @media screen and (max-width: ${LayoutConst.screen.l}px) {
        margin-top: 12px!important;
    }

    @media screen and (max-width: ${LayoutConst.screen.s-1}px) {
        margin-top: 24px!important;
    }
`;

export const QueueSubtitle = styled.div`
color:${Colors.galBlack73};
font-family: Inter;
font-size: 17px;
font-weight: 600;
line-height: 22px; 
letter-spacing: -0.02em;

@media screen and (max-width: ${LayoutConst.screen.s-1}px) {
    font-size: 15px;
    line-height: 20px; 
}
`;

export const SerialСardsContainer = styled.div`
display: flex;
flex-direction: row;
width: 100%;
max-height: 80px;
align-items: flex-start;
flex-wrap: wrap;
overflow-y: scroll;
margin-top: 16px;
gap:16px 24px;
padding-right:10px;

::-webkit-scrollbar {
    width: 2px;
    height: 48px;
}

::-webkit-scrollbar-track {
    background-color:${Colors.galBlack5};
}

::-webkit-scrollbar-thumb {
    background-color:${Colors.galBlack47};
}

  @media screen and (max-width: ${LayoutConst.screen.mac13}px) {
    gap:8px 16px;
  }

  @media screen and (max-width: ${LayoutConst.screen.s-1}px) {
    gap:8px 12px;
  }
`

export const SerialСard = styled.a`
color: ${Colors.galBlack100};
padding: 5px 16px;
border: 1px solid ${Colors.galBlack61};
border-radius: 5px;
cursor:pointer;
font-family: Inter;
font-size: 17px;
font-weight: 400;
line-height: 22px; 
letter-spacing: -0.02em;
max-width: 71px;
max-height: 32px;
box-sizing: border-box;

:hover{
    color:${Colors.galBlack100};
}

@media screen and (max-width: ${LayoutConst.screen.mac13}px) {
    font-size: 13px;
    line-height: 16px; 
    max-width: 62px;
    max-height: 26px;
}
`
